






















import Vue from 'vue';
import { Component, Model, Prop, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { NavLink } from '@/models/types';
import SgsMenuList from '@/components/SgsMenuList.vue';
const Nav = namespace('nav');

@Component({
  name: 'SgsMenuComponent',
  components: {
    SgsMenuList
  }
})
export default class SgsMenuComponent extends Vue {
  @Nav.Getter
  public navLinks!: NavLink[];
  @Nav.Getter
  public navLinksBottom!: NavLink[];
  @Prop()
  public icons!: boolean;

  @Model()
  private menuExpanded!: boolean;
  private menuExpandedInternal = false;

  constructor() {
    super();
    this.menuExpandedInternal = !Vue.prototype.isMobile();
  }

  @Watch('menuExpandedInternal')
  private menuExpandedInternalChanged(menuExpandedInternal: any) {
    // eslint-disable-next-line vue/custom-event-name-casing
    this.$emit('menuExpanded', menuExpandedInternal);
  }

  @Watch('menuExpanded')
  private menuExpandedChanged(menuExpanded: any) {
    this.menuExpandedInternal = menuExpanded;
  }

}

Vue.component('sgs-menu', SgsMenuComponent);
